export enum DocumentDescription {
  MortgageOffer = 'Hypotheekofferte',
  LoadAgreement = 'Overeenkomst van geldlening',
  SEPA = 'Getekende SEPA Machtiging'
}
